import { render } from "./toast-header.vue?vue&type=template&id=7f0484aa"
import script from "./toast-header.vue?vue&type=script&lang=js"
export * from "./toast-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__